<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <list-table background-color="#FFF">
        <form-items :data="dataDetail" :columns="2">
          <form-item label="企业微信id">
            {{dataDetail.qywxOrderId}}
          </form-item>
          <form-item label="商户名称">
            {{dataDetail.merchantName}}
          </form-item>
          <form-item label="账号类型">
            {{dataDetail.accountType === 1? '基础账号': '互通账号'}}
          </form-item>
          <form-item label="账号数量">
            {{dataDetail.accountNumber}}
          </form-item>
          <form-item label="账号时长">
            {{dataDetail.accountDuration}} 个月
          </form-item>
          <form-item label="订单状态">
            <div v-if="dataDetail.orderStatus === 0">待支付</div>
            <div v-if="dataDetail.orderStatus === 1">已支付</div>
          </form-item>
        </form-items>
        <yq-table :data="dataDetail.qywxOrderAccounts" height="auto">
          <yq-table-column label="账号类型">
            <template v-slot="scope">
              <div v-if="scope.row.accountType === 1">基础账号</div>
              <div v-if="scope.row.accountType === 2">互通账号</div>
            </template>
          </yq-table-column>
          <yq-table-column label="激活码" prop="activeCode"/>
          <yq-table-column label="激活时间" prop="activeTime"/>
          <yq-table-column label="到期时间" prop="expireTime"/>
          <yq-table-column label="绑定账号" prop="qywxOpenId" min-width="120rem"/>
          <yq-table-column label="职员名称" prop="employeeId">
            <template v-slot="{row}">
              <ww-open-data v-if="row.employeeId" type="userName" :openid="row.qywxOpenId" />
            </template>
          </yq-table-column>
          <yq-table-column  label="操作" prop="options" align="center" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button :disabled="!!row.activeTime" @click="toSelectUser(row)">激活</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page :show-page="false">
        <page-button type="write">保存</page-button>
      </form-page>
      <el-dialog title="激活账号" v-model="showActiveDialog" dialog-width="2">
        <form-items :data="currentData" :columns="1" label-width="2.4rem">
          <form-item label="激活码">
            <el-input v-model="currentData.activeCode" readonly/>
          </form-item>
          <form-item label="用户账号">
            <employee-select v-model="currentData.employeeId" :merchant-id="merchantId" @change="changeEmployeeInfo"/>
          </form-item>
        </form-items>
        <template #footer>
          <page-button @click="showActiveDialog = false">取消</page-button>
          <page-button el-type="primary" @click="activeAccount">激活</page-button>
        </template>
      </el-dialog>
      <employee-select v-model="currentData.employeeId"/>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import qywxOrderApi from "@/api/normal/sys/qywxOrderApi";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "QOD",
  components: {
    TableButtonGroup, TableButton,
    YqTableColumn,
    YqTable,EmployeeSelect,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem,
  },
  data() {
    return {
      dataDetail: {
        qywxOrderAccounts: []
      },
      currentData: {
        activeCode: "",
        employeeId: "",
        employeeQywxId: "",
      },
      showActiveDialog: false,
      merchantId: ""
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.merchantId = this.route.query.merchantId;
    // 注册企业微信通讯录组件
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.init();
    }
  },
  methods: {
    init() {
      this.findById(this.route.query.id);
    },
    findById(id) {
      qywxOrderApi.findById(id).then(data => {
        this.dataDetail = data;

      });
    },

    // 选中用户
    toSelectUser(data) {
      this.currentData = {...data};
      // 选择用户
      this.showActiveDialog = true;
    },
    // 激活账号
    activeAccount() {
      if (!this.currentData.employeeQywxId) {
        this.$message.error("请选择用户");
        return;
      }
      let param = {employeeId: this.currentData.employeeQywxId, code: this.currentData.activeCode, merchantId: this.route.query.merchantId}
      console.log("激活账号", param);
      qywxOrderApi.activeAccount(param).then(res => {
        this.$message.success("激活成功");
        this.showActiveDialog = false;
        console.log(res)
      });
    },
    changeEmployeeInfo(data) {
      this.currentData.employeeQywxId = data.qywxOpenId;
    }
  }
};
</script>

<style lang="scss" scoped>
.defaultViewStyle{

}
</style>